import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Close SVG Icon for close button.
 * @deprecated Use `@core/assets/Close` instead
 */
export const Close: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG
    width="100%"
    height="100%"
    viewBox="0 0 10 10"
    aria-hidden={true}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.0001 4.11116L8.32706 0.784202C8.57253 0.53873 8.97052 0.53873 9.21599 0.784202C9.46146 1.02967 9.46146 1.42766 9.21599 1.67314L5.88903 5.0001L9.21599 8.32706C9.46146 8.57253 9.46146 8.97052 9.21599 9.21599C8.97052 9.46146 8.57253 9.46146 8.32706 9.21599L5.0001 5.88903L1.67314 9.21599C1.42766 9.46146 1.02967 9.46146 0.784202 9.21599C0.53873 8.97052 0.53873 8.57253 0.784202 8.32706L4.11116 5.0001L0.784202 1.67314C0.53873 1.42766 0.53873 1.02967 0.784202 0.784202C1.02967 0.53873 1.42766 0.53873 1.67314 0.784202L5.0001 4.11116Z"
      fill={props.fill ?? 'currentColor'}
    />
  </AccessibleSVG>
)
